import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import Icon1 from '../assets/img/close-circle.svg';
import imgfomr from '../assets/img/modalimage-1.jpg';

const ContactModal = () => {
  const form = useRef();
  const [isSending, setIsSending] = useState(false);
  const [status, setStatus] = useState("");   // Success/Error msg
  const [isSubmitted, setIsSubmitted] = useState(false); // Form submit hone ka flag

  const sendEmail = async (e) => {
    e.preventDefault();
    setIsSending(true);
    setStatus("");

    const formData = new FormData(form.current);
    const jsonData = Object.fromEntries(formData.entries());

    try {
      // === 1. EmailJS send ===
      await emailjs.sendForm(
        "service_r1t9oq8",
        "template_fdzsqka",
        form.current,
        "o0-qZnllB8LkS2pa0"
      );

      // === 2. PHP API call (DB save ke liye) ===
      const response = await fetch("https://workdayz.in/save_modal_form.php", {
        method: "POST",
        body: JSON.stringify(jsonData),
        headers: { "Content-Type": "application/json" },
      });

      const result = await response.json();

      if (result.success) {
        setIsSubmitted(true);   // ✅ Form hide & thank you show
        form.current.reset();
      } else {
        setStatus("Database save failed: " + result.message);
      }
    } catch (error) {
      console.error("Error:", error);
      setStatus("Something went wrong.");
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div
      className="modal fade"
      id="staticBackdrop"
      tabIndex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body">
            <div className="formouter">
             <div className="forminfo">
                <img src={imgfomr} alt="" ></img>
             </div>
              <div className="formcontent">
                 <div class="modal-header">
                    <button type="button" class="btn-close" data-bs-dismiss="modal"><img src={Icon1} alt="" ></img></button>
                </div>
                {!isSubmitted ? (
                  // === Form ===
                  <form ref={form} className="contact_form modalform" onSubmit={sendEmail}>
                    <h2>Got an Idea? Let’s Make It Happen</h2>
                    <div className="row">
                      <div className="col-sm-12">
                        <input type="text" name="name" className="form-control" placeholder="Name" required />
                      </div>
                      <div className="col-sm-12">
                        <input type="email" name="email" className="form-control" placeholder="Email" required />
                      </div>
                      <div className="col-sm-12">
                        <input type="text" name="phone" className="form-control" placeholder="Phone" required />
                      </div>
                      <div className="col-sm-12">
                        <textarea name="message" className="messagebox" placeholder="What’s your requirement" required />
                      </div>
                    </div>
                    <button type="submit" className="btn btn-form" disabled={isSending}>
                      {isSending ? "Sending..." : "Get In Touch"}
                    </button>
                    {status && <p className="mt-3 text-danger">{status}</p>}
                  </form>
                ) : (
                  // === Thank You Message ===
                  <div className="thankyou-message text-center py-5">
                    <h3>🎉 Thank you!</h3>
                    <p>Your message has been sent successfully.</p>
                  </div>
                )}
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactModal;
